// 引入api
import { fun_PostAction, fun_GetAction } from "@/api";
import { mapState } from "vuex";
// 引入时间格式转换方法
import { formatDate } from "@/utils/validate.js";
import router from "@/router/router";
import VueRouter from "_vue-router@3.6.5@vue-router";
import Layout from "@/views/layout/Home";
export default {
  data() {
    return {
      // 通知
      informNum: null,
      // tab切换
      activeName: "1",
      // 列表loading状态
      loading: false,
      // 表单字段
      form: {
        tenderPrjName: null, // 项目名称
        investProjectCode: null, // 投资项目统一代码
        regulators: null, // 招标监管部门
        projectStateFlag: null, // 项目状态标志
        startTime: null, // 开始时间
        endTime: null // 截止时间
      },
      // 查询表单
      formSearchList: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 表格基础数据
      tableColumns: [
        {
          label: "待办事项",
          prop: "processName",
          isShow: true
        },
        {
          label: "任务名称",
          prop: "stepName"
        },
        {
          label: "数量",
          prop: "stepCount"
        },
        {
          label: "管理部门",
          prop: "regionName"
        }
      ],
      // 表格数据
      tableData: [],
      // 路由
      otherRouters: []
    };
  },
  created() {
    // 获取数据
    this.activeName = sessionStorage.getItem("activeName")
      ? sessionStorage.getItem("activeName")
      : "1";
  },
  // 注册组件
  components: {},
  // 模板编译完成
  mounted() {
    // 切换的tab
    this.fun_HandleClick();
  },
  methods: {
    /**
     * tabs切换
     * @param e 切换的值
     */
    fun_HandleClick() {
      // 重新分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 清空table
      this.tableData = [];
      // 获取分页总条数
      this.total = 0;
      // 待处理
      if (this.activeName === "1") {
        // 表格
        this.tableColumns = [
          {
            label: "待办事项",
            prop: "processName",
            isShow: true
          },
          {
            label: "任务名称",
            prop: "stepName"
          },
          {
            label: "数量",
            prop: "stepCount"
          },
          {
            label: "管理部门",
            prop: "regionName"
          }
        ];
        // 重新请求
        this.fun_GetToDoList();
      }
      // 核验历史
      else if (this.activeName === "2") {
        // 表格
        this.tableColumns = [
          {
            label: "历史事项",
            prop: "stepName",
            isShow: true
          },
          {
            label: "数量",
            prop: "sum"
          },
          {
            label: "管理部门",
            prop: "regionName"
          }
        ];
        // 重新请求
        this.fun_GetHistoryList();
      }
      // 我的项目或者历史项目
      else if (this.activeName === "3" || this.activeName === "4") {
        // 查询表单
        this.formSearchList = [
          {
            type: "input",
            label: "项目名称：",
            value: "tenderPrjName",
            placeholder: "请输入"
          },
          {
            type: "input",
            label: "投资项目统一代码：",
            value: "investProjectCode",
            placeholder: "请输入"
          },
          {
            type: "select",
            label: "行政监督部门：",
            value: "regulators",
            placeholder: "请选择",
            disabled: false,
            queryParams: {
              url: "/regulatorsCombobox",
              processType: "201510311952460006"
            }
          },
          {
            type: "select",
            label: "项目状态：",
            value: "projectStateFlag",
            placeholder: "请输入",
            optionData: [
              { name: "已完成项目", value: "0" },
              { name: "未完成项目", value: "1" }
            ]
          },
          {
            type: "date",
            label: "开始日期：",
            dateType: "date",
            value: "startTime",
            placeholder: "请输入",
            valueFormat: "yyyy-MM-dd"
          },
          {
            type: "date",
            label: "结束日期：",
            dateType: "date",
            value: "endTime",
            placeholder: "请输入",
            valueFormat: "yyyy-MM-dd"
          }
        ];
        // 表格
        this.tableColumns = [
          {
            label: "项目名称",
            prop: "tenderPrjName",
            isShow: true,
            minWidth: "300",
            fixed: true
          },
          {
            label: "标段编号",
            prop: "section",
            minWidth: "80",
            fixed: true
          },
          {
            label: "招标方式",
            prop: "tenderTypeNumName",
            minWidth: "100"
          },
          {
            label: "投资项目统一代码",
            prop: "investProjectCode",
            minWidth: "200"
          },
          {
            label: "公告开始时间",
            prop: "noticeStartDate",
            minWidth: "150"
          },
          {
            label: "资格审查方式",
            prop: "prequalificationTypeName",
            minWidth: "120"
          },
          {
            label: "行政监督部门",
            prop: "regulatorsName",
            minWidth: "250"
          }
        ];
        // 我的项目
        if (this.activeName == "3") {
          // 我的项目
          this.fun_GetProjectList();
        } else {
          // 历史项目
          this.fun_GetHistoryProjectList();
        }
      }
    },
    /**
     * 获取一览表格数据
     */
    async fun_GetToDoList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/auditProcess/toToList", {
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data.list;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
          // 任务总数
          this.informNum = data.sum;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取历史核验数据
     */
    async fun_GetHistoryList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/auditLog/auditHistoryGroup", {
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取本年项目一览信息
     */
    async fun_GetProjectList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/auditHome/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 获取历史项目一览信息
     */
    async fun_GetHistoryProjectList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction(
          "/auditHome/historyList",
          {
            ...this.form,
            ...this.reqPageData
          },
          60000
        );
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 待处理
      if (this.activeName == "1") {
        // 重新请求
        this.fun_GetToDoList();
      }
      // 历史核验
      else if (this.activeName == "2") {
        // 重新请求
        this.fun_GetHistoryList();
      }
      // 当年项目
      else if (this.activeName == "3") {
        // 我的项目
        this.fun_GetProjectList();
      }
      // 历史项目
      else {
        // 历史项目
        this.fun_GetHistoryProjectList();
      }
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      this.form[i] = e;
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 待处理
      if (this.activeName == "1") {
        // 重新请求
        this.fun_GetToDoList();
      }
      // 历史核验
      else if (this.activeName == "2") {
        // 重新请求
        this.fun_GetHistoryList();
      }
      // 当年项目
      else if (this.activeName == "3") {
        // 我的项目
        this.fun_GetProjectList();
      }
      // 历史项目
      else {
        // 历史项目
        this.fun_GetHistoryProjectList();
      }
    },
    /**
     * 数据字典查询
     * @author 滕威
     */
    fun_Search() {
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 待处理
      if (this.activeName == "1") {
        // 重新请求
        this.fun_GetToDoList();
      }
      // 历史核验
      else if (this.activeName == "2") {
        // 重新请求
        this.fun_GetHistoryList();
      }
      // 当年项目
      else if (this.activeName == "3") {
        // 我的项目
        this.fun_GetProjectList();
      }
      // 历史项目
      else {
        // 历史项目
        this.fun_GetHistoryProjectList();
      }
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 待处理
      if (this.activeName == "1") {
        // 重新请求
        this.fun_GetToDoList();
      }
      // 历史核验
      else if (this.activeName == "2") {
        // 重新请求
        this.fun_GetHistoryList();
      }
      // 当年项目
      else if (this.activeName == "3") {
        // 我的项目
        this.fun_GetProjectList();
      }
      // 历史项目
      else {
        // 历史项目
        this.fun_GetHistoryProjectList();
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     */
    fun_LookDetails(e) {
      // 判断是待核验
      if (this.activeName === "1") {
        // 跳转到指定界面
        this.$router.push({
          path: e.val.processPath,
          query: {
            sort: e.val.sort
          }
        });
      }
      // 判断是历史核验
      else if (this.activeName === "2") {
        // 跳转到指定界面
        this.$router.push({
          path: "/staffHistoricalVerification",
          query: {
            type: "staffHistoricalVerification",
            auditType: e.val.auditType
          }
        });
      }
      // 如果是当年项目或者历史项目
      else {
        // 项目详情
        this.fun_ProjectInfoDetail(e.val);
      }
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_ProjectInfoDetail(e) {
      // 请求，获取结果集
      fun_PostAction("/auditHome/projectTrackingDetail", {
        tenderReference: e.tenderReference, // 招标编号
        announcementId: e.id, // 招标公告编号
        registrationId: e.registrationId // 招标登记编号
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取路由
          var dataRouters = JSON.parse(data);
          // 遍历数据
          dataRouters.map(e => {
            // 转成数值
            e.order = Number(e.order);
          });
          // 存储路由
          sessionStorage.setItem(
            "workbenchRouters",
            JSON.stringify(dataRouters)
          );
          // Layout组件特殊处理
          dataRouters = [
            {
              component: "Layout",
              path: "/workbenchRouters",
              children: [...dataRouters]
            }
          ];
          console.log(dataRouters);
          // 存储用于判断显示菜单
          sessionStorage.setItem("workbenchMenu", "1");
          // 存储用于返回切换的tab
          sessionStorage.setItem("activeName", this.activeName);
          // 处理路由
          this.routerGo(dataRouters);
          // 如果是详情
          if (JSON.parse(data)[0].path.indexOf("Detail") !== -1) {
            // 默认跳转第一个
            this.$router.push({
              path: JSON.parse(data)[0].path,
              query: {
                id: "",
                controllerFlg: "detail",
                projectScheduleNum: Number(e.projectScheduleNum)
              }
            });
          } else {
            // 默认跳转第一个
            this.$router.push({
              path: JSON.parse(data)[0].path,
              query: { projectScheduleNum: Number(e.projectScheduleNum) }
            });
          }
        }
      });
    },
    routerGo(routerJson) {
      this.filterOtherRouter(routerJson);
      let asyncRouters = this.filterAsyncRouter(routerJson);
      global.antRouter = asyncRouters; //将路由数据传递给全局变量，做侧边栏菜单渲染工作
    },

    filterAsyncRouter(asyncRouterMap) {
      //遍历后台传来的路由字符串，转换为组件对象
      const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
          if (route.component === "Layout") {
            //Layout组件特殊处理
            route.component = Layout;
          } else {
            route.component = this.componentImport(route.component);
          }
        }
        if (route.children && route.children.length) {
          route.children = this.filterAsyncRouter(route.children);
        }
        return true;
      });
      return accessedRouters;
    },

    filterOtherRouter(asyncRouterMap) {
      for (let i in asyncRouterMap) {
        let otherRouter = {};
        if (asyncRouterMap[i].component) {
          if (asyncRouterMap[i].component === "Layout") {
            //Layout组件特殊处理
          } else {
            otherRouter.name = asyncRouterMap[i].name.replace(
              asyncRouterMap[i].name,
              asyncRouterMap[i].name + "Detail"
            );
            otherRouter.path = asyncRouterMap[i].path.replace(
              asyncRouterMap[i].path,
              asyncRouterMap[i].path + "Detail"
            );
            otherRouter.meta = {};
          }
        }
        if (otherRouter.name) {
          this.otherRouters.push(otherRouter);
        }
        if (asyncRouterMap[i].children && asyncRouterMap[i].children.length) {
          asyncRouterMap[i].children = this.filterOtherRouter(
            asyncRouterMap[i].children
          );
        }
      }
      return asyncRouterMap;
    },
    componentImport(component) {
      return () => import("../../../../views/" + component);
    }
  }
};
